import { FC, useEffect, useState } from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import type { DiscoverTourCompany, DiscoverTourFilters } from '../../../../../types/tour.types';
import DiscoverIdeasFilters from '../DiscoverFilters/DiscoverIdeasFilters';
import CustomButton from '../../../../../common/CustomButton';

import styles from '../FlightFiltersModal/FlightFiltersModal.module.scss';

type DiscoverFiltersModalProps = {
  open: boolean;
  onClose: () => void;
  filters: DiscoverTourFilters;
  onApply: (next: DiscoverTourFilters) => void;
  companies: DiscoverTourCompany[];
};

const DiscoverFiltersModal: FC<DiscoverFiltersModalProps> = ({
  open,
  onClose,
  filters,
  onApply,
  companies,
}) => {
  const [draft, setDraft] = useState<DiscoverTourFilters>(filters);

  useEffect(() => {
    if (open) {
      setDraft(filters);
    }
  }, [open, filters]);

  const handleApply = () => {
    onApply(draft);
    onClose();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(34, 43, 58, 0.35)' },
        },
      }}
      PaperProps={{
        className: styles.drawerPaper,
        elevation: 8,
      }}
    >
      <Box className={styles.header}>
        <Typography
          variant="h8Bold"
          className={styles.title}
        >
          Filters
        </Typography>
        <IconButton
          type="button"
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close filters"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box className={styles.body}>
        <DiscoverIdeasFilters
          filters={draft}
          onFiltersChange={setDraft}
          companies={companies}
        />
      </Box>

      <Box className={styles.footer}>
        <CustomButton
          variant="outlined"
          btnType="button"
          onClick={onClose}
          customClass={styles.footerBtn}
        >
          Cancel
        </CustomButton>
        <CustomButton
          variant="contained"
          btnType="button"
          onClick={handleApply}
          customClass={styles.footerBtn}
        >
          Apply filters
        </CustomButton>
      </Box>
    </Drawer>
  );
};

export default DiscoverFiltersModal;
